type BlendshapeData = {
  time: number;
  blendshapes: Record<string, number>;
};

// 通过 CDN 地址获取文件并格式化
async function formatBlendshapes(url: string): Promise<BlendshapeData[]> {
  if (!url) {
    return [];
  }
  try {
    // 使用 fetch 从 CDN 获取文件内容
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`无法从 ${url} 获取文件: ${response.statusText}`);
    }

    // 将文件内容解析为文本
    const fileContent = await response.text();
    
    // 调用工具函数来处理文本内容
    return formatBlendshapesFromText(fileContent);

  } catch (error: any) {
    throw new Error(`获取或解析文件时发生错误: ${error.message}`);
  }
}

export default formatBlendshapes;

// 解析文本内容并格式化成指定的 JSON 格式
function formatBlendshapesFromText(fileContent: string): BlendshapeData[] {
  const lines = fileContent.split('\n').map(line => line.trim()).filter(line => line.length > 0);

  // 从第一行解析 sampleRate
  const [sampleRateLabel, sampleRateValue] = lines[0].split(' ');
  if (sampleRateLabel !== 'sampleRate' || isNaN(parseFloat(sampleRateValue))) {
    throw new Error('文件的第一行格式不正确，必须是 "sampleRate 0.02" 这样的格式');
  }
  const sampleRate = parseFloat(sampleRateValue);

  const blendshapeValues: Record<string, number[]> = {};
  let totalFrames = 0;

  // 从第二行开始处理 blendshape 数据
  lines.slice(1).forEach(line => {
    const [blendshapeName, ...values] = line.split(' ');

    if (blendshapeName && values.length > 0) {
      const numericValues = values.map(Number);
      blendshapeValues[blendshapeName] = numericValues;

      // 更新总帧数
      totalFrames = Math.max(totalFrames, numericValues.length);
    }
  });

  const formattedData: BlendshapeData[] = [];

  // 生成每个时间点的 blendshape 数据
  for (let i = 0; i < totalFrames; i++) {
    const blendshapes: Record<string, number> = {};

    for (const blendshape in blendshapeValues) {
      blendshapes[blendshape] = blendshapeValues[blendshape][i] || 0; // 如果某帧无数据，默认值为0
    }

    const time = i * sampleRate;
    formattedData.push({ time, blendshapes });
  }

  return formattedData;
}